// utils/permissionUtils.js

export const collectPermissions = (node) => {
  let perms = [];

  if (node.permission) {
    perms.push(node.permission);
  }

  if (node.children?.length) {
    node.children.forEach(child => {
      perms = perms.concat(collectPermissions(child));
    });
  }

  return perms;
};

export const isAllChecked = (node, selected) => {
  const perms = collectPermissions(node);
  return perms.length > 0 && perms.every(p => selected.includes(p));
};

export const isSomeChecked = (node, selected) => {
  const perms = collectPermissions(node);
  return (
    perms.some(p => selected.includes(p)) &&
    !isAllChecked(node, selected)
  );
};
